import { React, useState, useEffect } from 'react';
import fieldImage from "/app/src/images/field.svg";
import TeamCompositionPlayer from "./TeamCompositionPlayer";
import AverageIcon from "./../images/icons/average.svg";

export default function TeamComposition({ data }) {

    if (!data) return;

    const teamAFormation = data.eventParticipants[0]?.lineup?.formation?.name || '';
    const teamBFormation = data.eventParticipants[1]?.lineup?.formation?.name || '';

    // PlayerId -> Player (for both teams)
    const getPlayersByIds = () => {
        const playersByIds = {};
        data.eventParticipants[0]?.lineup?.players?.forEach(player => {
            playersByIds[player.id] = player;
        });
        data.eventParticipants[1]?.lineup?.players?.forEach(player => {
            playersByIds[player.id] = player;
        });
        return playersByIds;
    };

    // RowNumber -> Player[] (for each team separately)
    const getTeamFormationRows = (teamNumber) => {
        const playersByIds = getPlayersByIds();
        const rows = {};
        data.eventParticipants[teamNumber]?.lineup?.formation?.lines[0]?.rows?.forEach(row => {
            row.playerIds?.forEach(playerId => {
                rows[row.sortKey] = row.playerIds?.map(id => playersByIds[id]);
            });
        });
        return Object.values(rows);
    };
    const teamAFormationRows = getTeamFormationRows(0);
    const teamBFormationRows = getTeamFormationRows(1);

    const teamARating = data.eventParticipants[0]?.averageRating ? Number(data.eventParticipants[0]?.averageRating) : null;
    const teamBRating = data.eventParticipants[1]?.averageRating ? Number(data.eventParticipants[1]?.averageRating) : null;

    const ratingColor = (rating) => {
        if (rating >= 7.5) return '#0aa00a';
        if (rating >= 7.0) return '#7dd83b';
        if (rating >= 6.5) return '#facf31';
        if (rating >= 6.0) return '#fdb119';
        return '#e53e19';
    };

    if (!teamAFormation || !teamBFormation) return;

    return (
    <div className="team-composition">
        <div className="match-time">
            <span>{teamAFormation}</span>
            <span>РАССТАНОВКА</span>
            <span>{teamBFormation}</span>
        </div>
        <div 
            className="team-composition__field" 
        >
            {teamARating && 
            <div 
                className="team-composition__rating team-composition__rating--A"
                style={{backgroundColor: ratingColor(teamARating)}}
            >
                <img src={AverageIcon} />
                { teamARating }
            </div>}
            {teamBRating && 
            <div 
                className="team-composition__rating team-composition__rating--B"
                style={{backgroundColor: ratingColor(teamBRating)}}
            >
                <img src={AverageIcon} />
                { teamBRating }
            </div>}
            <div className="team-composition__players">
                <div className="team-composition__team-players">
                    { teamAFormationRows.map(row => <FormationRow data={row} />) }
                </div>
                <div className="team-composition__team-players">
                    { teamBFormationRows.map(row => <FormationRow data={row} />) }
                </div>
            </div>
        </div>
    </div>);

}

function FormationRow({ data }) {
    console.log('FormationRow', data);
    return (<div className="team-composition__row" key={data[0]}>
        {data.map(player => <TeamCompositionPlayer data={player} />)}
    </div>);
}